import {
  faAlarmClock, faClock, faMemoPad, faTruck,
} from '@fortawesome/pro-light-svg-icons'

const generateDeadlineTabItems = (agencyIdParam: string) => [
  {
    href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/deadlines`,
    icon: faClock,
    key: 'deadlines',
    title: "Today's Deadlines",
  },
  {
    href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/deadlines/providers`,
    icon: faTruck,
    key: 'provider-deadlines',
    title: 'Provider Deadlines',
  },
  {
    href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/deadlines/publications`,
    icon: faMemoPad,
    key: 'publication-deadlines',
    title: 'Publication Deadlines',
  },
  {
    href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/deadlines/customDeadlines`,
    icon: faAlarmClock,
    key: 'custom-deadlines',
    title: 'Custom Deadlines',
  },

]

export default generateDeadlineTabItems
